import React from "react";
import ShoppingBasketOutlinedIcon from "@material-ui/icons/ShoppingBasketOutlined";
import { getCheckoutLineId } from "../domain/cartContext";
import { getCartLineDetails, getCartProductPresentation } from "../domain/cartPresentation";
import { getProduct } from "../../store/reducers/store";
import { getCartReasonLabel } from "../domain/cartChangeReasons";

export default function CartChangePreview({ preview, cart = {}, categories = [], language = "english" }) {
  const arabic = language === "arabic";
  const items = [...(cart.cart || []), ...(cart.promo_items || [])];
  return <ul className="context-sheet__changed-items">
    {[...(preview.removedLines || []).map(line => ({ ...line, group: "removed" })),
      ...(preview.adjustedLines || []).map(line => ({ ...line, group: "adjusted" }))].map(line => {
      const item = items.find((item, index) => getCheckoutLineId(item, index) === String(line.lineId || line.line_id)) || {};
      const product = getProduct(categories, item.id, item.category_id, item.parent) || item;
      const presentation = getCartProductPresentation({ item, product,
        parentProduct: item.parent ? getProduct(categories, item.parent, item.category_id) : null }, language);
      const image = product.photo_thumb || product.photo_small || product.photo || item.photo;
      const details = getCartLineDetails(item, product, language);
      const removed = line.group === "removed";
      const originalQuantity = Number(line.originalQuantity) > 0 ? line.originalQuantity : item.quantity || 1;
      return <li key={`${line.group}-${line.lineId || line.line_id}`}>
        <span className="context-sheet__changed-image">{image ? <img src={image} alt="" /> : <ShoppingBasketOutlinedIcon />}</span>
        <div><strong>{presentation.name || (arabic && line.ar_name) || line.name || (arabic ? "منتج في السلة" : "Cart item")}</strong>
          {presentation.variants && <p>{presentation.variants}</p>}
          {!!details.length && <p>{details.join(" · ")}</p>}
          <p className={removed ? "is-removed" : "is-adjusted"}>{removed
            ? arabic ? `سيتم استبعاده · الكمية ${originalQuantity}` : `Will be removed · Qty ${originalQuantity}`
            : arabic ? `الكمية: ${originalQuantity} ← ${line.quantity}` : `Qty: ${originalQuantity} → ${line.quantity}`}</p>
          {line.reason && <p>{getCartReasonLabel(line.reason, language)}</p>}
        </div>
      </li>;
    })}
  </ul>;
}
